import {useContext} from 'react'

import Context from '@s-ui/react-context'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'

const formName = 'tasacion vehiculo'

const useVehicleAppraiserAnalyticsTrack = ({pageName} = {}) => {
  const {track} = useAnalyticsTrack()
  const {domain} = useContext(Context)
  const {fieldNameToTrackingIds, formErrorTypes, formFieldIds} = domain.get('config').get('form')

  const getTrackingErrorData = ({errorType, formErrors = {}, formName, customErrors = '', fields}) => {
    const isFieldErrorType = errorType === formErrorTypes.fieldError
    const data = {
      page_error: isFieldErrorType ? formErrorTypes.fieldError : formErrorTypes.serverError
    }

    if (isFieldErrorType) {
      data.page_error = formErrorTypes.fieldError
      if (formName) data.form_name = formName

      data.form_fields = Object.keys(formErrors).reduce((acc, fieldKey) => {
        const fieldError = formErrors[fieldKey]
        const fieldErrorId = fieldNameToTrackingIds[fieldKey].property
        if (fieldKey === 'plate' && fieldError.length) {
          data.hit_information = !fields.plate ? 'matricula vacia' : 'matricula incorrecta'
        }
        if (!fieldError.length) return acc
        return !acc ? fieldErrorId : `${acc}:${fieldErrorId}`
      }, customErrors)
    }

    return data
  }

  const trackInstantOfferError = ({errorType, formErrors = {}, isPrivacyChecked, fields}) => {
    const privacyCheckError = !isPrivacyChecked ? fieldNameToTrackingIds[formFieldIds.privacyCheck].property : ''
    return track({
      event: `Appraisal Select Dealer Error`,
      data: getTrackingErrorData({
        errorType,
        formErrors,
        customErrors: privacyCheckError,
        fields
      })
    })
  }

  const trackAppraisalError = ({errorType, formErrors = {}}) => {
    return track({
      event: `Appraisal Requested Error`,
      data: getTrackingErrorData({errorType, formErrors, formName})
    })
  }

  const trackFormFieldValueAutocompleted = ({fieldId}) => {
    return track({
      event: `Appraisal Field Autocompleted`,
      data: {
        hit_information: 'unica opcion',
        pta_automatic_field: fieldNameToTrackingIds[fieldId].property
      }
    })
  }

  const trackFormFieldValueChange = ({fieldId}) => {
    return track({
      event: `Appraisal ${fieldNameToTrackingIds[fieldId].field} Selected`
    })
  }

  const trackInstantOfferSuccess = ({ioId}) => {
    return track({
      event: `Appraisal Select Dealer Confirmed`,
      data: {
        io_id: ioId
      }
    })
  }

  const trackAppraisalRequested = ({isTargetIO, vehicleData = {}}) => {
    const paramsTrack = {
      event: `Appraisal Requested`,
      data: {
        form_name: formName,
        hit_information: isTargetIO ? 'es target io' : 'no es target io'
      }
    }
    const formFields = Object.keys(vehicleData)
      .reduce((previus, current) => {
        !vehicleData[current] && previus.push(fieldNameToTrackingIds[current].property)
        return previus
      }, [])
      .join(':')

    if (formFields) {
      paramsTrack.data.form_fields = formFields
    }

    return track(paramsTrack)
  }

  const trackOnClickPublishButton = () => {
    return track({event: 'Appraisal To Ad Insertion Clicked'})
  }

  const trackOnClickChooseProssionalButton = () => {
    return track({event: 'Appraisal To IO Clicked'})
  }

  const trackOnClickBuyButton = () => {
    return track({event: 'Appraisal To Search Clicked'})
  }

  return {
    trackAppraisalError,
    trackAppraisalRequested,
    trackFormFieldValueAutocompleted,
    trackFormFieldValueChange,
    trackInstantOfferError,
    trackInstantOfferSuccess,
    trackOnClickBuyButton,
    trackOnClickPublishButton,
    trackOnClickChooseProssionalButton
  }
}

export {useVehicleAppraiserAnalyticsTrack}
